query getMarketsByIds($ids: [String], $minutely: Boolean, $fetch_logo: Boolean) {
    getMarketsByIds(ids: $ids, minutely: $minutely, fetch_logo: $fetch_logo)
}
